/**
 * Accordion progressive enhancement for <details> elements.
 * Adds smooth open/close animation and proper ARIA attributes.
 */
(function () {
  var items = document.querySelectorAll('.faq__item');
  if (!items.length) return;

  items.forEach(function (details) {
    var summary = details.querySelector('summary');
    if (!summary) return;

    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', details.hasAttribute('open') ? 'true' : 'false');

    summary.addEventListener('click', function () {
      // Update aria-expanded on next tick (after browser toggles open)
      requestAnimationFrame(function () {
        summary.setAttribute('aria-expanded', details.hasAttribute('open') ? 'true' : 'false');
      });
    });
  });
})();
